import { PropsWithChildren } from 'react';
import { LocalizedSubsectionTitle } from '@mews-commander/ui';
import { Stack } from '@optimus-web/core';

export function SecuritySubsection({ title, children }: PropsWithChildren<{ title: Mews.TextKey }>) {
    return (
        <Stack vertical spacing="200">
            <LocalizedSubsectionTitle textKey={title} />
            {children}
        </Stack>
    );
}
